import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ManageRoleType } from '@/types/manage-role';

export type ManageRoleState = {
  dataManageRole: ManageRoleType[];
  isLoading: boolean;
};

export const manageRoleInitialState: ManageRoleState = {
  dataManageRole: [],
  isLoading: false,
};

const slice = createSlice({
  name: 'manageRole',
  initialState: manageRoleInitialState,
  reducers: {
    setManageRoleListAction(state, { payload }: PayloadAction<ManageRoleType[]>) {
      state.dataManageRole = payload;
    },
    setManageRoleLoadingAction(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload;
    },
  },
});

export const { setManageRoleListAction, setManageRoleLoadingAction } = slice.actions;
export default slice.reducer;
